export default __webpack_public_path__ + "benefits-section-2.png";